import type { Product } from '@/js/services/RogueTypes'
import type { ProductMeasurementConfig } from '../RackTypes'
import { MMS_GROUPED_SKU } from './mms-utils/mms-constants'
import { MMS_MEASUREMENT_CONFIG } from './mms-utils/mms-measurement-config'
import { MS_GROUPED_SKU } from './ms-utils/ms-constants'
import { MS_MEASUREMENT_CONFIG } from './ms-utils/ms-measurement-config'
import { CAVE_SKUS } from '../products/cave/utils/caveConstants'
import { CAVE_MEASUREMENT_CONFIG } from '../products/cave/utils/caveMeasurementConfig'
import { HYBRID_RIG_SKUS } from '../products/rig/hybrid/hybridConstants'
import { HYBRID_MEASUREMENT_CONFIG } from '../products/rig/hybrid/hybridMeasurementConfig'
import { TRAP_BAR_MEASUREMENT_CONFIG } from '../products/bar/trapBarMeasurementConfig'

type ConfigEntry = {
  matches: (product: Product | undefined) => boolean
  config: ProductMeasurementConfig
}

// Add new product configs here. Each config lives in its product's utils directory.
export const MEASUREMENT_CONFIG: ConfigEntry[] = [
  {
    matches : (product) => product?.sku === MMS_GROUPED_SKU,
    config  : MMS_MEASUREMENT_CONFIG,
  },
  {
    matches : (product) => product?.sku === MS_GROUPED_SKU,
    config  : MS_MEASUREMENT_CONFIG,
  },
  {
    matches : (product) => CAVE_SKUS.includes(String(product?.sku)),
    config  : CAVE_MEASUREMENT_CONFIG,
  },
  {
    matches : (product) => HYBRID_RIG_SKUS.includes(String(product?.sku)),
    config  : HYBRID_MEASUREMENT_CONFIG,
  },
  {
    matches : (product) => product?.roguebuilder?.props?.rackbuilder?.type === 'tb3',
    config  : TRAP_BAR_MEASUREMENT_CONFIG,
  },
]

export const DEFAULT_MEASUREMENT_CONFIG: ProductMeasurementConfig = {
  dynamic          : false,
  defaultZoomLevel : 3,
}
